<div class="page">
  <app-page-info mode="view" [pageId]="pageId" (saved)="reload()" (deleted)="onDeleted()"></app-page-info>
</div>
